import React from 'react';

type LabelType = 'urgent' | 'critical' | 'normal' | 'low';

interface TaskLabelProps {
  type: LabelType;
}

const getLabelColor = (type: LabelType) => {
  switch (type) {
    case 'urgent':
      return 'bg-[#F97316] text-white';
    case 'critical':
      return 'bg-[#D946EF] text-white';
    case 'normal':
      return 'bg-[#E5DEFF] text-slate-700';
    case 'low':
      return 'bg-[#F2FCE2] text-slate-700';
    default:
      return 'bg-slate-100 text-slate-700';
  }
};

const TaskLabel: React.FC<TaskLabelProps> = ({ type }) => {
  return (
    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getLabelColor(type)}`}>
      {type.charAt(0).toUpperCase() + type.slice(1)}
    </span>
  );
};

export default TaskLabel;